import {
  productIdFormat,
  storageLocationIdFormat,
  transferOrderIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

const BinAssignmentSchema = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  productId: productIdFormat.schema,
  quantity: z.number().int().positive(),
});

export const submitTransferOrder = {
  name: "submitTransferOrder" as const,
  input: z.object({
    transferId: transferOrderIdFormat.schema,
    // Optional bin assignments for WMS SOT origin locations.
    // When provided, a transfer session is created instead of an adjustment session.
    originBinAssignments: z.array(BinAssignmentSchema).nullish(),
  }),
  output: z.object({ success: z.literal(true) }),
};
